import { styled } from "theme/default/styled";

export const SHeaderMenu = styled.div`
  position: relative;
`;
